import styled, { css } from "styled-components";

export type ButtonVariant = 'primary' | 'secondary' | 'onboarding' | 'error';

const getButtonVariant = (variant?: ButtonVariant) => {
  switch (variant) {
    case 'primary':
      return css`
        background-color: var(--primary);
        color: var(--black-100);
      `
    case 'secondary':
      return css`
        background-color: var(--white);
        color: var(--black-100);
      `
    case 'onboarding':
      return css`
        background-color: var(--black-300);
        color: var(--white);
      `
    case 'error':
      return css`
        background-color: var(--red);
        color: var(--white);
      `;
    default:
      return css`
        background-color: var(--primary);
        color: var(--black-100);
      `
  }
}

type ButtonWrapperProps = {
  variant: ButtonVariant;
  isFetching: boolean;
}

export const ButtonWrapper = styled.button<ButtonWrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  gap: 8px;

  width: auto;
  height: 3rem;

  font-size: 1rem;
  font-family: Inter, sans-serif;
  font-weight: 500;

  border-radius: 0.3rem;

  cursor: pointer;

  padding: 0rem 1.2rem;

  &:disabled {
    cursor: ${props => props.isFetching ? 'progress' : 'not-allowed' };
    background: #f2f2f3;
    opacity: 0.3;
    color: #000;
  }

  transition: opacity 0.3s ease-in-out;

  &:hover:enabled {
    opacity: 0.7;
  }

  ${props => getButtonVariant(props.variant)}
`;

export const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20rem;
  height: 3rem;
  text-decoration: none;
  color: #000;
  background: var(--primary);
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.1rem;
  font-family: Inter;
  border-radius: 0.3rem;
  cursor: pointer;
  border: var(--primary);
  transition: all 0.3s ease-in-out;

  &:disabled {
    cursor: not-allowed;
    background: #f2f2f3;
    opacity: 0.3;
    color: #000;
  }

  &:hover:enabled {
    background: var(--primary);
  }

  @media (max-width: 768px) {
    padding: 1rem 1.5rem;
    width: 12.5rem;
    height: 3.5rem;
    margin-top: 2rem;
    margin-left: 1.4375rem;
    font-size: 0.875rem;
    line-height: 0.875rem;
    margin-bottom: 0px;
  }
`;

export const EditButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8.125rem;
  height: 2.5rem;
  text-decoration: none;
  color: white;
  background: var(--black-400);
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 1.1rem;
  border-radius: 0.3rem;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 1rem 1.5rem;
    width: 12.5rem;
    height: 3.5rem;
    margin-top: 2rem;
    margin-left: 1.4375rem;
    font-size: 0.875rem;
    line-height: 0.875rem;
    margin-bottom: 0px;
  }
`;

export const ReportButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12.875rem;
  height: 2.5rem;
  text-decoration: none;
  color: #000;
  background: var(--primary);
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 1.1rem;
  border-radius: 0.3rem;
  cursor: pointer;

  &:hover {
    background: var(--primary);
  }
`;

export const NextButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22.5rem;
  height: 2.5rem;
  text-decoration: none;
  color: #000;
  background: var(--primary);
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 1.1rem;
  border-radius: 0.3rem;
  cursor: pointer;

  &:hover {
    background: var(--primary);
  }
`;

export const ApprovalButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 20px;
  height: 32px;
  background: var(--green);
  border-radius: 4px;
  font-family: "Inter";
  font-style: normal;
  font-size: 14px;
  line-height: 16px;
  color: #191919;
`;

export const RefuseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 20px;
  height: 32px;
  background-color: var(--black-200);
  border-radius: 4px;
  font-family: "Inter";
  font-style: normal;
  font-size: 14px;
  line-height: 16px;
  color: var(--white);
`;
